import { CustomerInvoice, CustomerInvoiceListItem } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for Customer invoices
 */
export class CustomerInvoices extends CrudApiBase<CustomerInvoice, CustomerInvoiceListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03-rc/api/customer-invoices";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): CustomerInvoice {
    return {
      info: {},
      bases: [],
      invoice: {
        rows: [],
      },
    };
  }

  /**
   * Saves an item to the storage.
   * NOTE: Access to this method is very restricted by design as invoces are created by Palkkaus and cannot be modified by the Customer.
   * Typically, you will not be able to save customer invoices in the production environment.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  public save(itemToSave: CustomerInvoice): Promise<CustomerInvoice> {
    return super.save(itemToSave);
  }
}
